import type { ReactNode } from "react";
import { createContext, useCallback, useContext, useState } from "react";
import type { MenuMultiOption } from "@saviynt/design-system";
import { WORKFORCE_TAB } from "../constants/policies.constants";

export interface PoliciesFilterValues {
  searchValue: string;
  selectedFilters: Record<string, MenuMultiOption[]>;
}

interface PoliciesFilterContextType {
  filterValues: PoliciesFilterValues;
  setFilterValues: (values: PoliciesFilterValues) => void;
  isFilterReady: boolean;
  markFilterReady: () => void;
}

const PoliciesFilterContext = createContext<
  PoliciesFilterContextType | undefined
>(undefined);

export function PoliciesFilterProvider({ children }: { children: ReactNode }) {
  const [filterValues, setFilterValues] = useState<PoliciesFilterValues>({
    searchValue: "",
    selectedFilters: {
      category: [
        { value: WORKFORCE_TAB, label: WORKFORCE_TAB, isChecked: true },
      ],
    },
  });
  const [isFilterReady, setIsFilterReady] = useState(false);
  const markFilterReady = useCallback(() => setIsFilterReady(true), []);

  return (
    <PoliciesFilterContext.Provider
      value={{ filterValues, setFilterValues, isFilterReady, markFilterReady }}
    >
      {children}
    </PoliciesFilterContext.Provider>
  );
}

export const usePoliciesFilter = () => {
  const context = useContext(PoliciesFilterContext);
  if (!context) {
    throw new Error(
      "usePoliciesFilter must be used within PoliciesFilterProvider",
    );
  }
  return context;
};
